import get from 'lodash/get';
import { OPTION_TYPES } from '../util/constants';
import { SelectFieldFilterDef } from './filter-definition';

export class FilterManager {
    constructor(props) {}

    static createFilterDef(fieldTemplate) {
        if (
            fieldTemplate.type === OPTION_TYPES.MULTISELECT ||
            fieldTemplate.type === OPTION_TYPES.SELECT
        ) {
            return new SelectFieldFilterDef(fieldTemplate);
        }
    }

    static evaluateRow(row, filterDefs) {
        if (!filterDefs?.length) {
            return true;
        }
        return filterDefs.every((filterDef) => {
            return filterDef.filter(row);
        });
    }

    static getSelectedData(filterDefsSelectedData, filterDef) {
        const selectedData = get(filterDefsSelectedData ?? {}, filterDef.path);
        return selectedData;
    }
}
